"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InfiniteLoaderDesktop_1 = require("./InfiniteLoaderDesktop");
exports.default = InfiniteLoaderDesktop_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/InfiniteLoader/InfiniteLoaderDesktop/index.js
// module id = 665
// module chunks = 8